import AxiosHttpFactory from '@/features/api/axiosHttpFactory'
import { ErrorTransformInterceptor } from '@/features/api/errorTransformInterceptor'
import { ILicenceAPI } from '@/features/api/licence/types'
import { MissingNetworkConnectionInterceptor } from '@/features/api/missingNetworkConnectionInterceptor'
import { ILicence } from '@/types/licence'
import { IProfile } from '@/types/profile'

class LicenceAPI implements ILicenceAPI {
    private $licenceAPI = AxiosHttpFactory.createMultiClient()

    constructor() {
        new MissingNetworkConnectionInterceptor(this.$licenceAPI)

        new ErrorTransformInterceptor(this.$licenceAPI)
    }

    setHostUrl(url: string) {
        this.$licenceAPI.defaults.baseURL = `${url}/api/terminal-licence`
    }

    setAccessToken(token: string) {
        this.$licenceAPI.defaults.headers.common['Authorization'] = token
    }

    async fetchLicenceData() {
        const { data } = await this.$licenceAPI.get<ILicence>('/licence-data')

        return data
    }

    async fetchProfiles() {
        const { data } = await this.$licenceAPI.get<IProfile[]>('/profiles')

        return data
    }

    async registerFCMToken(token: string, consumerUuid: string) {
        await this.$licenceAPI.post('/messaging-tokens/actions/register', {
            token,
            consumerUuid,
            appType: 'terminal',
        })
    }
}

export default new LicenceAPI()
